<template>
  <div class="significance">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">

      <el-form-item label="分析标题">
        <el-input v-model="formInline.analysisTitle" placeholder="分析标题"></el-input>
      </el-form-item>
      <el-form-item label="分析量表">
        <el-input v-model="formInline.paperID" placeholder="分析量表"></el-input>
      </el-form-item>
      <el-form-item label="发布主题">
        <el-input v-model="formInline.publishID" placeholder="发布主题"></el-input>
      </el-form-item>
      <el-form-item label="分析对象">
        <el-input v-model="formInline.deptID" placeholder="分析对象"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button type="primary" @click="onSubmit">重置</el-button>
        <el-button type="primary" @click="add()">新增</el-button>
      </el-form-item>
    </el-form>

    <div class="nav">
      <template>
        <el-table :data="tableData" style="width: 98%;margin-left:1%;padding-top:14px">
          <el-table-column prop="analysisTitle" label="分析标题" width="180"></el-table-column>
          <el-table-column prop="paperName" label="分析量表" width="180"></el-table-column>
          <el-table-column prop="publishSubject" label="发布主题"></el-table-column>
          <el-table-column prop="deptName" label="分析对象"></el-table-column>
          <el-table-column prop="startDate" label="开始时间"></el-table-column>
          <el-table-column prop="endDate" label="结束时间"></el-table-column>
          <el-table-column prop="address" label="是否启用">
            <template slot-scope="scope">
              <span>{{scope.row.isActive==1?'是':'否'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="w" @click="del(scope.row)">删除</span>
              <span class="w" @click="xiugai(scope.row)">修改</span>
              <span class="w" @click="bg(scope.row)">报告</span>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNum" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      formInline: {
        analysisTitle: '',
        paperID: '',
        publishID: '',
        deptID: '',
      },
      pageNum:1,
      Counts:0,
      tableData: []
    }
  },
  beforeCreate() {

  },
  methods: {
    bg(row){
      this.$router.push({
        path: '/Measurement/significance_report',
        query: { analysisKey:row.analysisKey},
      })


    },
    del(row){
      var s = [row.analysisKey]
      this.$Http_Post('/paper/analysis/delete', {
        analysisKeys: s,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          this.Global.request_successful(res.Message);
          this.loading()
        }else{
          this.Global.request_failure(res.Message);
        }
      });
    },
    xiugai(row){
      this.$router.push({
        path: '/Measurement/significance_add',
        query: { paperID: row.paperID,analysisKey:row.analysisKey},

      })
    },
    onSubmit() {
      this.loading()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loading();
    },
    loading(){
      this.$Http_Post('paper/analysis/list', {
        analysisTitle: this.formInline.analysisTitle,
        paperID:  this.formInline.paperID,
        publishID:  this.formInline.publishID,
        deptID:  this.formInline.deptID,
        pageNum:  this.pageNum,
        pageSize:  '10',
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          this.tableData = res.Data;
          this.Counts = res.Counts;
        }else{
          this.Global.request_failure(res.Message);
        }
      });
    },
    add(){
      this.$router.push({
        path: '/Measurement/significance_add',
      })
    }
  },
  created() {
    this.loading()
  },
}
</script>
<style>
.significance {width: 100%;height: 100%;}
.significance .demo-form-inline{padding: 14px;width: calc(100% - 28px);background-color: #fff;}
.significance .nav{width: 100%;height: calc(100% - 104px);background-color: #fff;margin-top: 14px;}
</style>
